import { useFormContext, UseFormRegister } from 'react-hook-form';
import { get, pickBy } from 'lodash';
import { ZodObject } from 'zod';

export function useFormFieldState(props: {
  name: string;
  register?: UseFormRegister<any>;
}) {
  const formContext = useFormContext<any>();
  const error = get(formContext?.formState.errors, props.name);
  const isSubmitting = formContext?.formState.isSubmitting;
  const registerFn = props.register ? props.register : formContext.register;

  return { error, formContext, isSubmitting, register: registerFn };
}

export function useSchemaFormContext<T extends ZodObject<any>>(schema: T) {
  const formContext = useFormContext<T>();
  const reset = (values: any) => {
    formContext.reset(
      // TODO fix
      // eslint-disable-next-line no-prototype-builtins
      pickBy(values, (v, k) => schema.shape.hasOwnProperty(k)) as any,
    );
  };
  return { ...formContext, reset };
}
